import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useRef,useContext } from 'react';
import "../index.css";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CloseIcon from '@mui/icons-material/Close';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { IoTriangleOutline } from "react-icons/io5";
import { GrEmptyCircle } from "react-icons/gr";
import { FaStopCircle,FaPlayCircle } from "react-icons/fa";
import axios from 'axios';
import { ProductContext } from "../context/AppContext";
import ListeningQuizFooter from './Common_Components/Footer';
function MockTestListeningQuiz() {
    const location = useLocation();
    const [selectedOption, setSelectedOption] = useState(null);
    const [isCorrect, setIsCorrect] = useState(null);
    const [timer, setTimer] = useState(0); // Start timer from 0
    const [activePage, setActivePage] = useState("Learning");
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true); // Disable submit initially
    const navigate = useNavigate();
    const [showResultButtons, setShowResultButtons] = useState(false); // Control when to show the new buttons
    const [isAnswerCorrect, setIsAnswerCorrect] = useState(null); // Track whether the answer is correct
    const [explanation, setExplanation] = useState([]);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const authToken = localStorage.getItem("AuthToken");
    const { Translate } = useContext(ProductContext);
    const [sound, setSound] = useState(null);
    // const [selectedOption, setSelectedOption] = useState(null);
    const [quizData, setQuizData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [timeSpent, setTimeSpent] = useState(0);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [showSubmitMessage, setShowSubmitMessage] = useState(false);
    const [attemptStatus, setAttemptStatus] = useState(null);
    const [hasMoreQuestions, setHasMoreQuestions] = useState(true);
    const [attemptstatus22, setAttemptStatus22] = useState();
    const [attemptedQuestions, setAttemptedQuestions] = useState(0);
    const [isOptionSelected, setIsOptionSelected] = useState(false);
    const [soundPlayed, setSoundPlayed] = useState(false);
    const soundRef = useRef(null);
    const audioRef = useRef(null);
    const [language, setLanguage] = useState('english');
    const [text, setText] = useState({});
    const swingAnimRef = useRef();

    const categoryData = location.state; // Receive the state passed during navigation
    const category_id = categoryData?.category_id;
    const categoryName = categoryData?.categoryName; // Match property name
    const level_id = categoryData?.level_id;
    const exam_id = categoryData?.exam_id;
    const test_name_id = categoryData?.test_name_id;
    const question_type_id = categoryData?.question_type_id;
    const { quizTypeId, quizName } = location.state || {};
    const [loading, setLoading] = useState(false);

    console.log(quizTypeId, quizName,  "quizTypeId, quizName Quiz")
   
    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = await localStorage.getItem('selectedLanguage');
                setLanguage(storedLanguage || 'english');
            } catch (error) {
                console.error('Error loading language:', error);
            }
        };

        loadLanguage();
    }, []);


    useEffect(() => {
        fetchQuizData(currentPage);
    }, [currentPage]);

  
  const togglePlayPause = async (audioUrl) => {
    if (!audioRef.current) {
      // Initialize the audio if it doesn't exist
      audioRef.current = new Audio(audioUrl);
      audioRef.current.onended = () => setIsPlaying(false); // Reset state when audio ends
    }

    if (isPlaying) {
      audioRef.current.pause(); // Pause the audio
    } else {
      audioRef.current.play(); // Play the audio
    }
    setIsPlaying(!isPlaying); // Toggle the play/pause state
  };

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause(); // Stop playback
      audioRef.current.currentTime = 0; // Reset to the beginning
      setIsPlaying(false); // Update the state
    }
  };

  const handlePlayAudio = async (audioUrl) => {
    try {
      await togglePlayPause(audioUrl);
    } catch (error) {
      console.log("Error playing sound: ", error);
    }
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      // Stop audio when component unmounts
      stopAudio();
    };
  }, []);
    // useEffect(() => {
    //     const unsubscribe = navigation.addListener('blur', () => {
    //         stopSound();
    //         setSoundPlayed(false);
    //     });

    //     return unsubscribe;
    // }, [navigation]);


    useEffect(() => {
        const timer = setInterval(() => {
            setTimeSpent(prevTime => prevTime + 1);
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    // console.log("this is the category name and id ", categoryName, category_id)

    const fetchQuizData = async page => {
        setIsLoading(true);
        try {
            const isFilteredListeningFlow =
                Boolean(category_id) &&
                Boolean(exam_id) &&
                Boolean(test_name_id) &&
                Boolean(question_type_id);

            const response = await axios.get(
                isFilteredListeningFlow
                    ? `https://api.japaking.online/api/categories/questions/filter?page=${page}&size=6&category_id=${category_id}&exam_id=${exam_id}&test_name_id=${test_name_id}&question_type_id=${question_type_id}`
                    : `https://api.japaking.online/api/categories/${category_id}?page=${page}&size=6`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.data.success) {
                const newQuestions = isFilteredListeningFlow
                    ? response?.data?.message?.questions || []
                    : response?.data?.message?.category?.questions || [];
                setQuizData(prevData => [
                    ...prevData,
                    ...newQuestions.filter(
                        q => !prevData.some(p => p.question_id === q.question_id),
                    ),
                ]);
                // console.log("These are new questions ", newQuestions)
                if (newQuestions.length < 6) {
                    setHasMoreQuestions(false);
                }
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                console.log("navigate to login due to 401");
                navigate("Login");
            }
            console.log('Error fetching quiz data:', err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSelect = optionId => {
        setSelectedOption(optionId);
        setShowSelectAnswerMessage(false);
    };


    const submitUserAttempt = async () => {
        const currentQuestion = quizData[currentQuestionIndex];
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption,
        );
        const userAttemptData = {
            questionId: currentQuestion.question_id,
            optionId: selectedOption,
            attemptStatus: selectedOptionData
                ? selectedOptionData.is_correct
                    ? 'correct'
                    : 'incorrect'
                : null,
        };
        // console.log(userAttemptData, "userAttemptData");
        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            // console.log('User attempt submitted successfully:', response?.data);

            setAttemptStatus(response.data.message.attempt.attempt_status);
            setAttemptStatus22(response?.data?.message);
        } catch (error) {
            console.log('Error submitting user attempt:', error);
        }
    };
    
    const [showSelectAnswerMessage, setShowSelectAnswerMessage] = useState(false);

    const handleSubmit = async () => {
        if (!selectedOption) {
            setShowSelectAnswerMessage(true); // Show message if no option is selected
            return;
        }

        await submitUserAttempt(); // Submit the user attempt to the backend

        const currentQuestion = quizData[currentQuestionIndex];
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption
        );

        // Update the correctness and show the result buttons
        const answerCorrect = selectedOptionData?.is_correct || false;
        setIsCorrect(answerCorrect);
        setShowResultButtons(true); // Show the result buttons
        setIsSubmitted(true);
    };

    const handleNextQuestion = () => {
        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
        } else if (hasMoreQuestions && quizData.length > 0) {
            setCurrentPage(nextPage => nextPage + 1);
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
        } else {
            // navigate('/ListeningQuizThankYou', {
            //     categoryId: category_id,
            //     total_time_spent: timeSpent,
            //     quizTypeId: quizTypeId,
            //     quizName: quizName,
            // });
            navigate('/ListeningQuizThankYou', {
  state: {
    categoryId: category_id,
    total_time_spent: timeSpent,
    quizTypeId,
    quizName,
  },
});

        }
    };

    // const handleStartNewQuiz = () => {

    //   if (currentQuestionIndex < quizData.length - 1) {
    //     setCurrentQuestionIndex(currentQuestionIndex + 1);
    //     setShowSubmitMessage(false);
    //     setSelectedOption(null);
    //   } else if (hasMoreQuestions) {
    //     setCurrentPage(nextPage => nextPage + 1);
    //     setShowSubmitMessage(false);
    //     setSelectedOption(null);
    //   }
    // };

    
    const currentQuestion = quizData[currentQuestionIndex];
    const progress22 = `${currentQuestionIndex + 1}/${quizData.length}`;
    const progressPercentage = (currentQuestionIndex + 1) / quizData.length;
  
    if (isLoading) {
        // return (
        //     <View style={styles.LoadingImageDiv}>
        //         <Image source={LoadingImage} style={styles.LoadingImageCss} />
        //     </View>
        // );
    }
    const formatTime = seconds => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };

    const renderAudioPlayer = (src, label) => {
        if (!src) return null;
        return (
            <div style={{ marginTop: '8px' }}>
                <p style={{ marginBottom: '4px', fontWeight: 600 }}>{label}</p>
                <audio controls src={src} style={{ width: '100%' }}>
                    Your browser does not support the audio element.
                </audio>
            </div>
        );
    };

    // console.log("This si tiem spend ", timeSpent)

    const handleMoveToQuestion = () => {
        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
           navigate('/MockTestListeningQuiz', {
                category_id: category_id,
            });
        } else {
            // navigate('/ListeningQuizThankYou', {
            //     category_id: category_id,
            //     quizTypeId: quizTypeId,
            //     quizName: quizName,
            // });
            navigate('/ListeningQuizThankYou', {
  state: {
    categoryId: category_id,
    total_time_spent: timeSpent,
    quizTypeId,
    quizName,
  },
});

        }
        setShowSubmitMessage(false);
    };
    const handleStartNewQuiz = () => {
        console.log('CURRENT QUESTION INDEX ', currentQuestionIndex);
        console.log('QUIZ DATA LENGTH ', quizData.length);
        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
            setIsSubmitted(false);
            setShowResultButtons(false); // Reset to initial state
            setIsAnswerCorrect(null);
        } else {
            console.log('i am here in else22 ');
            // navigate('/ListeningQuizThankYou', {
            //     categoryId: category_id,
            //     total_time_spent: timeSpent,
            //     quizTypeId: quizTypeId,
            //     quizName: quizName,
            // });
            navigate('/ListeningQuizThankYou', {
  state: {
    categoryId: category_id,
    total_time_spent: timeSpent,
    quizTypeId,
    quizName,
  },
});

        }
    };

    const handleSkip = async () => {
        // Ensure `currentQuestion` is defined
        const currentQuestion = quizData[currentQuestionIndex];
        if (!currentQuestion || !currentQuestion.options) {
            console.error("Current question or options are undefined");
            return;
        }
    
        // Find the selected option (if options exist)
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption
        );
    
        const userAttemptData = {
            questionId: currentQuestion.question_id,
            attemptStatus: 'un_attempt'
        };
    
        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
    
            setAttemptStatus(response?.data?.message?.attempt?.attempt_status);
            setAttemptStatus22(response?.data?.message);
        } catch (err) {
            if (err.response && err.response.status === 401) {
                console.log("navigate to login due to 401");
                navigate("Login");
            }
            console.error("Error submitting user attempt:", err);
        }
    
        handleNextQuestion();
    };
    
    const handleSureMove = async () => {
        const currentQuestion = quizData[currentQuestionIndex];
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption,
        );
        const userAttemptData = {
            questionId: currentQuestion.question_id,

            attemptStatus: 'confirm',
        };
        // console.log(userAttemptData, "userAttemptData");
        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            // console.log('User attempt submitted successfully:', response?.data);

            setAttemptStatus(response.data.message.attempt.attempt_status);
            setAttemptStatus22(response?.data?.message);
            setShowResultButtons(false);
        } catch (error) {
            console.log('Error submitting user attempt:', error);
        }
        handleNextQuestion();
    };

    const handeReattempt = async () => {
        const currentQuestion = quizData[currentQuestionIndex];
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption,
        );
        const userAttemptData = {
            questionId: currentQuestion.question_id,

            attemptStatus: 're_attempt',
        };
        // console.log(userAttemptData, "userAttemptData");
        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            // console.log('User attempt submitted successfully:', response?.data);

            setAttemptStatus(response.data.message.attempt.attempt_status);
            setAttemptStatus22(response?.data?.message);
            setShowResultButtons(false);
        } catch (error) {
            console.log('Error submitting user attempt:', error);
        }
        handleNextQuestion();
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer((prevTimer) => prevTimer + 1);
        }, 1000);

        return () => clearInterval(interval); // Clean up on unmount
    }, []);

    const handleOptionClick = (index) => {
        setSelectedOption(index); // Set the selected option
        setIsSubmitDisabled(false); // Enable the submit button
    };

    useEffect(() => {
        if (!isLoading && quizData.length === 0) {

            navigate("/coming-soon");
        }
    }, [isLoading, currentQuestion, navigate]);
    const [selectedLanguage, setSelectedLanguage] = useState('');
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
  
    console.log(SelectLanguageLocal, "SelectLanguageLocal")
    useEffect(() => {
      const loadLanguage = async () => {
        try {
          const storedLanguage = localStorage.getItem("selectedLanguage");
          console.log("storedLanguage",storedLanguage);
          if (storedLanguage) {
            setSelectedLanguage(storedLanguage);
          }
        } catch (error) {
          console.error("Error loading language:", error);
        }
      };
  
      loadLanguage();
    }, []);
    return (
        <div className='Profile_Design_Main_Div_11 mock-listening-quiz-page'>
            <div className='header_inner'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className='icon_1' />                          
                                <h2>{showResultButtons
                                    ? Translate?.message?.data?.quizResult || "Quiz Result"
                                    : Translate?.message?.data?.listeningQuiz || "Listening Quiz"}</h2>                       
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container JLPT_Quiz" style={{ marginTop: "75px", marginBottom: "75px", height: "auto" }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div
                                className={`quiz-container ${isSubmitted ? "left" : ""}`}
                            >
                                <div className="quiz-header">
                                    <div className="quiz-info">
                                        <span>{currentQuestionIndex + 1}/{quizData.length}</span>
                                    </div>
                                    <div className="quiz-timer">
                                        <span>{formatTime(timeSpent)}</span>
                                    </div>
                                </div>
                                <div className="progress-bar-container" style={{ backgroundColor: 'gray', height: '10px', borderRadius: '5px' }}>
                                    <div
                                        className="progress-bar"
                                        style={{
                                            width: `${progressPercentage}%`,
                                            backgroundColor: '#ffc0cb',
                                            height: '100%',
                                            borderRadius: '5px',
                                        }}
                                    ></div>
                                </div>



                                <div className="quiz-question">
                                    <div className="quiz-header">
                                            <h6>{Translate?.message?.data?.selectTheCorrectTranslations || "Select the correct Answer"}</h6>                                  
                                    </div>
                                   
                                </div>

                                <div style={{ marginBottom: '14px' }}>
                                    {currentQuestion?.url && (
                                        <p style={{ marginBottom: '6px' }}>
                                            <strong>URL: </strong>
                                            <a href={currentQuestion.url} target="_blank" rel="noreferrer">Open media</a>
                                        </p>
                                    )}

                                    {(currentQuestion?.url || currentQuestion?.audio_url) && (
                                        <div style={{ marginBottom: '10px' }}>
                                            <div className="quiz-header">
                                                <h6>Question Audio</h6>
                                            </div>
                                            <div className="quiz-question-container">
                                                <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                                <div className="quiz-question-box" style={{ textAlign: 'left' }}>
                                                    <p
                                                        onClick={() => handlePlayAudio(currentQuestion?.url || currentQuestion?.audio_url)}
                                                        style={{ fontWeight: "500", fontSize: "20px", margin: 0, cursor: 'pointer', textAlign: 'left' }}
                                                    >
                                                        {isPlaying ? (
                                                            <FaStopCircle size={40} color="#ffc0cb" />
                                                        ) : (
                                                            <FaPlayCircle size={40} color="#ffc0cb" />
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div style={{ marginTop: '8px' }}>
                                        <div className="quiz-header">
                                            <h6>Question Image</h6>
                                        </div>
                                        <div className="quiz-question-container">
                                            <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                            <div className="quiz-question-box" style={{ textAlign: 'left' }}>
                                                {currentQuestion?.question_image ? (
                                                    <div className="mock-question-image-frame">
                                                        <img
                                                            src={currentQuestion.question_image}
                                                            alt="Question"
                                                            className="mock-question-image"
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="mock-question-image-frame mock-question-image-frame-empty">
                                                        No question image
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                 <div className="quiz-header">
                                                <h6>Question Text</h6>
                                            </div>
 <div className="quiz-question-container">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                        <div className="quiz-question-box">
                                            <h7>{currentQuestion?.question_text || "Question text not available"}</h7>

                                        </div>
                                    </div>
                                <div className="quiz-options-container">
                                    <div className="quiz-options">
                                        {currentQuestion?.options?.length > 0 ? (
                                            currentQuestion.options.map((option) => (
                                                <button
                                                    key={option.option_id}
                                                    className={`quiz-option ${selectedOption === option.option_id
                                                        ? isSubmitted && isCorrect === true
                                                            ? 'correct' // Apply correct class if the option is correct
                                                            : isSubmitted && isCorrect === false
                                                                ? 'incorrect' // Apply incorrect class if the option is incorrect
                                                                : 'selected' // Apply selected class if the option is selected
                                                        : ''
                                                        }`}
                                                    onClick={() => handleSelect(option.option_id)}
                                                    disabled={isSubmitDisabled && selectedOption !== null} // Disable options after submitting
                                                >
                                                    <span
                                                        className={`quiz-option-text ${selectedOption === option.option_id
                                                            ? 'selected-text' // Apply selected-text class if the option is selected
                                                            : ''
                                                            }`}
                                                    >
                                                        {option.option_text || 'Option'} {/* Fallback text for option */}
                                                    </span>

                                                    {/* Feedback messages displayed only after submission */}
                                                    {isSubmitted && selectedOption === option.option_id && isCorrect === false && (
                                                        <span className="responsive-incorrect">
                                                            <CloseIcon className="quiz-close-icon" />
                                                            {Translate?.message?.data?.incorrect || "Incorrect"}
                                                        </span>
                                                    )}

                                                    {isSubmitted && selectedOption === option.option_id && isCorrect === true && (
                                                        <span className="responsive-correct">
                                                            <RadioButtonUncheckedIcon
                                                                className="quiz-checked-icon"
                                                            />
                                                             {Translate?.message?.data?.correct || "Correct"}
                                                        </span>
                                                    )}
                                                </button>
                                            ))
                                        ) : (
                                            <p>No options available</p> // Fallback UI for no options
                                        )}
                                        {showSelectAnswerMessage && (
                                            <h7 style={{
                                                color: 'red',
                                                marginTop: 5,
                                                textAlign: 'left', // Align the text to the right
                                            }}>
                                                {Translate?.message?.data?.pleaseSelectAnAnswer || " Please select an answer."}
                                            </h7>
                                        )}
                                    </div>
                                </div>
                                <div className="quiz-controls">
                                    <div className="quiz-buttons">
                                        {showResultButtons ? (
                                            isCorrect ? (
                                                <>
                                                    {/* Explanation Box */}
                                                    <div className="quiz-content">
                                                        <div className={`explanation-corect-box-listquiz ${!currentQuestion?.text_explanation && !currentQuestion?.image_explanation && !currentQuestion?.audio_explanation && !currentQuestion?.options?.[0]?.option_description ? 'hidden' : ''}`}>
                                                            <h5>{Translate?.message?.data?.explanation || "Explanation"}:</h5>

                                                            {currentQuestion?.audio_explanation && (
                                                                <div className="quiz-question-container" style={{ marginBottom: '8px' }}>
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                                                    <div className="quiz-question-box" style={{ textAlign: 'left' }}>
                                                                        <p style={{ marginBottom: '4px', fontWeight: 600 }}>Audio Explanation</p>
                                                                        <p
                                                                            onClick={() => handlePlayAudio(currentQuestion.audio_explanation)}
                                                                            style={{ fontWeight: "500", fontSize: "20px", margin: 0, cursor: 'pointer', textAlign: 'left' }}
                                                                        >
                                                                            {isPlaying ? (
                                                                                <FaStopCircle size={40} color="#ffc0cb" />
                                                                            ) : (
                                                                                <FaPlayCircle size={40} color="#ffc0cb" />
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {currentQuestion?.image_explanation && (
                                                                <div className="quiz-question-container" style={{ marginBottom: '8px' }}>
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                                                    <div className="quiz-question-box" style={{ textAlign: 'left' }}>
                                                                        <p style={{ marginBottom: '4px', fontWeight: 600 }}>Image Explanation</p>
                                                                        <div
                                                                            style={{
                                                                                maxHeight: '280px',
                                                                                overflowY: 'auto',
                                                                                border: '1px solid #e5e7eb',
                                                                                borderRadius: '10px',
                                                                                padding: '4px',
                                                                                background: '#fff',
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={currentQuestion.image_explanation}
                                                                                alt="Image explanation"
                                                                                style={{ maxWidth: '100%', borderRadius: '8px', objectFit: 'contain' }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {currentQuestion?.text_explanation && (
                                                                <div className="quiz-question-container" style={{ marginBottom: '8px' }}>
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                                                    <div className="quiz-question-box" style={{ textAlign: 'left', background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                                                        <p style={{ marginBottom: '4px', fontWeight: 600 }}>Text Explanation</p>
                                                                        <p style={{ marginBottom: 0 }}>{currentQuestion.text_explanation}</p>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {currentQuestion?.options?.[0]?.option_description && currentQuestion?.options?.map((option, i) => (
                                                                <div key={i} className="explanation-item">
                                                                    <span>{option?.option_description}</span>
                                                                </div>
                                                            ))}
                                                        </div>


                                                        {/* Buttons for Correct Answer */}
                                                        <div
                                                            className={`result-buttons-correct ${!currentQuestion?.options?.[0]?.option_description ? 'no-explanation' : ''
                                                                }`}
                                                        >
                                                          
                                                                <button className="quiz-submit" onClick={handleSureMove}>
                                                                   {Translate?.message?.data?.dontWantToReattempt || "Don’t Want to Reattempt"}
                                                                    <div className="reattempt-icon">
                                                                        <GrEmptyCircle size={20} color="white" />
                                                                    </div>
                                                                </button>                                                                                                      
                                                                <button className="quiz-submit" onClick={handeReattempt}>
                                                                     {Translate?.message?.data?.wantToReattempt || "Want to Reattempt"}
                                                                    <div className="want-reattempt-icon">
                                                                        <IoTriangleOutline size={20} color="white" />
                                                                    </div>
                                                                </button>
                                                            

                                                            <div className="mock-result-dual-actions" style={{ display: 'flex', gap: '8px', width: '100%' }}>
                                                                <button className="quiz-submit" style={{ flex: 1 }} onClick={handleStartNewQuiz}>
                                                                    {Translate?.message?.data?.moveToNext || "Move to Next"}
                                                                </button>
                                                                <button className="quiz-submit" style={{ flex: 1 }} onClick={() => navigate("/")}>
                                                                   {Translate?.message?.data?.backToHome || "Back to Home"}
                                                                </button>
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    {/* Explanation Box */}
                                                    {(currentQuestion?.text_explanation || currentQuestion?.image_explanation || currentQuestion?.audio_explanation || currentQuestion?.options?.[0]?.option_description) && (
                                                        <div className="explanation-incorect-box-listquiz">
                                                            <h5>{Translate?.message?.data?.explanation || "Explanation"}</h5>
                                                            {currentQuestion?.audio_explanation && (
                                                                <div className="quiz-question-container" style={{ marginBottom: '8px' }}>
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                                                    <div className="quiz-question-box" style={{ textAlign: 'left' }}>
                                                                        <p style={{ marginBottom: '4px', fontWeight: 600 }}>Audio Explanation</p>
                                                                        <p
                                                                            onClick={() => handlePlayAudio(currentQuestion.audio_explanation)}
                                                                            style={{ fontWeight: "500", fontSize: "20px", margin: 0, cursor: 'pointer', textAlign: 'left' }}
                                                                        >
                                                                            {isPlaying ? (
                                                                                <FaStopCircle size={40} color="#ffc0cb" />
                                                                            ) : (
                                                                                <FaPlayCircle size={40} color="#ffc0cb" />
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {currentQuestion?.image_explanation && (
                                                                <div className="quiz-question-container" style={{ marginBottom: '8px' }}>
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                                                    <div className="quiz-question-box" style={{ textAlign: 'left' }}>
                                                                        <p style={{ marginBottom: '4px', fontWeight: 600 }}>Image Explanation</p>
                                                                        <div
                                                                            style={{
                                                                                maxHeight: '280px',
                                                                                overflowY: 'auto',
                                                                                border: '1px solid #e5e7eb',
                                                                                borderRadius: '10px',
                                                                                padding: '4px',
                                                                                background: '#fff',
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={currentQuestion.image_explanation}
                                                                                alt="Image explanation"
                                                                                style={{ maxWidth: '100%', borderRadius: '8px', objectFit: 'contain' }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {currentQuestion?.text_explanation && (
                                                                <div className="quiz-question-container" style={{ marginBottom: '8px' }}>
                                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
                                                                    <div className="quiz-question-box" style={{ textAlign: 'left', background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                                                        <p style={{ marginBottom: '4px', fontWeight: 600 }}>Text Explanation</p>
                                                                        <p style={{ marginBottom: 0 }}>{currentQuestion.text_explanation}</p>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            {currentQuestion?.options?.map((option, i) => (
                                                                <div key={i} className="explanation-item">
                                                                    <span>{option?.option_description}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}

                                                    {/* Buttons for Incorrect Answer */}
                                                    <div className="result-buttons-incorrect">
                                                        
                                                            <div className="mock-result-dual-actions" style={{ display: 'flex', gap: '8px', width: '100%' }}>
                                                                <button className="quiz-submit" style={{ flex: 1 }} onClick={handleStartNewQuiz}>
                                                                   {Translate?.message?.data?.moveToNext || "Move to Next"}
                                                                </button>

                                                                <button className="quiz-submit" style={{ flex: 1 }} onClick={() => navigate("/")}>
                                                                    {Translate?.message?.data?.backToHome || "Back to Home"}
                                                                </button>
                                                            </div>
                                                       
                                                    </div>
                                                </>
                                            )
                                        ) : (
                                            <>
                                                {/* Initial Buttons */}
                                                <div>
                                                    {loading ? (
                                                        // Show a loading state for the button
                                                        <button
                                                            className="quiz-submit"
                                                            style={{ backgroundColor: "White", cursor: "not-allowed" }}
                                                            disabled
                                                        >
                                                            Loading...
                                                        </button>
                                                    ) : (
                                                        <>
                                                            {currentQuestion?.length >= 6 ? (
                                                                // Render the button without any action if the condition is met
                                                                <>
                                                                   
                                                                        <button
                                                                            className="quiz-submit"
                                                                            style={{ backgroundColor: "White", cursor: "not-allowed" }}
                                                                            disabled
                                                                        >
                                                                            {Translate?.message?.data?.skipToNext || "Skip to Next"}
                                                                        </button>
                                                                 
                                                                </>
                                                            ) : (
                                                                // Render the button with the onClick handler for skipping
                                                                <>
                                                                  
                                                                        <button
                                                                            className="quiz-submit"
                                                                            onClick={handleSkip}
                                                                            style={{ backgroundColor: "White" }}
                                                                        >
                                                                             {Translate?.message?.data?.skipToNext || "Skip to Next"}
                                                                        </button>
                                                                   
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                                <div>
                                                   
                                                        <button className="quiz-submit" onClick={() => handleSubmit()}>
                                                           {Translate?.message?.data?.submit || "Submit"}
                                                        </button>
                                                    
                                                </div>
                                            </>
                                        )}


                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
      <ListeningQuizFooter />
    </div>
  );
}
export default MockTestListeningQuiz;
// import React, { useState, useEffect } from 'react';
// import { FaStopCircle,FaPlayCircle } from "react-icons/fa";
// import { Link, useNavigate } from 'react-router-dom';
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import CloseIcon from '@mui/icons-material/Close';
// import CheckIcon from '@mui/icons-material/Check';
// import Footer from './Common_Components/Footer';
// import HomeIcon from '@mui/icons-material/Home';
// import EditIcon from '@mui/icons-material/Edit';
// import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
// import Person4Icon from '@mui/icons-material/Person4';

// const ListeningQuiz = () => {
//     const [activePage, setActivePage] = useState("Learning");
//     const [isPlaying, setIsPlaying] = useState(false);
//     const navigate = useNavigate();
  
//     const togglePlayPause = () => {
//         setIsPlaying((prev) => !prev);
//       };





// const authToken = localStorage.getItem("AuthToken");
// //   console.log(authToken);

// const fetchQuestionData = useCallback(async () => {
//     try {
//         const response = await fetch(
//             `https://api.japaking.online/api/questions`,
//             {
//                 method: "GET",
//                 headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${authToken}`,
//                 },
//             }
//         );

//         if (!response.ok) {
//             throw new Error("Network response was not ok");
//         }
//         const responseData = await response.json();
//         const data = responseData.message.questions;


//         const based1 = data.filter((e) => e.category_id === parseInt(category_id));
//         console.log(based1)
//         setQuestions(based1)
//         console.log("fetched data", data);



//     } catch (error) {
//         console.error("There was a problem with the fetch operation:", error);
//     }
// }, [authToken, category_id]);

// const fetchOptionsData = useCallback(async () => {

//     if (questions.length === 0) {
//         console.log("questions data is still loading...");
//         return;
//     }

//     try {
//         const response = await fetch(
//             `https://api.japaking.online/api/options`,
//             {
//                 method: "GET",
//                 headers: {
//                     "Content-Type": "application/json",
//                     Authorization: `Bearer ${authToken}`,
//                 },
//             }
//         );

//         if (!response.ok) {
//             throw new Error("Network response was not ok");
//         }

//         const responseData = await response.json();
//         const data = responseData.message.options;
//         console.log("Options fetched successfully");



//         if (score < questions.length) {
//             const questionId = questions[score].question_id;
//             console.log(questionId)
//             const filteredOptions = data.filter(
//                 (option) => option.question_id === questionId
//             );

//             setOptions(filteredOptions);
//             console.log("Filtered options:", filteredOptions);
//             console.log("fetched data", data);

//         }


//     } catch (error) {
//         console.error("There was a problem with the fetch operation:", error);
//     }
// }, [authToken, questions, score]);


// useEffect(() => {
//     fetchQuestionData();
// }, [fetchQuestionData]);

// useEffect(() => {
//     if (questions.length > 0) {
//         fetchOptionsData();
//     }
// }, [questions, fetchOptionsData]);


// if (questions.length === 0) {
//     console.log("options data is still loading...");
//     return;
// }

// const questionText = questions.length > 0 ? questions[score].question_text : '';

// const handelQuestion = () => {
//     if (score <= scoreLimit) {
//         setScore((prevScore) => prevScore + 1);
//     }
//     else {
//         setScore(0);
//     }
//     setSubmit(false);

// };

// const handleSelectOption = (isCorrect) => {
//     setSelect(isCorrect);
// };

  
//   return (  
//     <div className='Profile_Design_Main_Div_11'>
//     <div className='header_inner'>
//         <div className='container'>
//             <div className='row'>
//                 <div className='col-md-12'>
//                     <ArrowBackIosIcon onClick={() => navigate('/JLPTQuiz')} className='icon_1' />
//                     <h2>Quiz</h2>
//                     <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
//                 </div>
//             </div>
//         </div>
//     </div>
 
//     <div className="tiles-wrapper">
//         <div className='container'>
//             <div className='row'>
//                 <div className='col-md-12'>
//                     <div className="quiz-container">
//                         <div className="quiz-header">
//                             <div className="quiz-info">
//                                 {/* <span>{currentQuestion + 1}/{questions.length}</span> */}
//                             </div>
//                             <div className="quiz-timer">
//                                 {/* <span>{formatTime(timer)}</span> */}
//                             </div>
//                         </div>
//                         <div className="progress-bar-container" style={{ backgroundColor: 'gray', height: '10px', borderRadius: '5px' }}>
//                             <div
//                                 className="progress-bar"
//                                 style={{
//                                     width: `50%`,
//                                     backgroundColor: '#ffc0cb',
//                                     height: '100%',
//                                     borderRadius: '5px',
//                                 }}
//                             ></div>
//                         </div>
//                         <div className="quiz-question">
//                             <div className="quiz-header">
//                                 <h6>Select the correct translation</h6>
//                             </div>
//                             <div className="quiz-question-container">
//                                 <img src={`${process.env.PUBLIC_URL}/assets/images/question15.png`} alt="icon" className="question-icon" />
 
//                                 <div className="quiz-question-box">
//                                 <p onClick={togglePlayPause} style={{fontWeight:"500",fontSize:"20px"}}> {isPlaying ? <FaStopCircle size={40} color='red' /> : <FaPlayCircle size={40} color='red' />} </p> 
//                                     {/* <h7>{questions[currentQuestion].question}</h7> */}
//                                 </div>
//                             </div>
//                         </div>
 
//                         <div className="quiz-options-container">
//                             {/* <div className="quiz-options">
//                                 {.options.map((option, index) => (
//                                     <button
//                                         key={index}
                            
//                                     >
                                    
                                      
//                                     </button>
//                                 ))}
//                             </div> */}
//                         </div>
 
//                         <div className="quiz-controls">
//                             <div className="quiz-buttons">
//                                 <button
//                                     className="quiz-submit"
                                   
//                                     style={{ backgroundColor: 'White' }}
//                                 >
//                                     Skip to Next
//                                 </button>
//                                 <button
//                                     className="quiz-submit"
                                  
//                                 >
//                                     Submit
//                                 </button>

                               
//                             </div>
//                             <div className="next-btn">
//                               <button className='me-2' style={{backgroundColor:"#fafafa", border:"1px solid #ccc",borderRadius:"5px",padding:"8px 12px" }}>Move to next</button>
//                               <button  style={{backgroundColor:"#fafafa", border:"1px solid #ccc",borderRadius:"5px",padding:"8px 12px" }}>Back To Home</button>
//                            </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     </div>
//           <Footer />
 
//  </div>
 
//   )
// }

// export default ListeningQuiz
